export const ASSURANCE_LEVY = 20;
export const COD_MAX_AMOUNT = 2000;

export function isCodEligible(grandTotal, pincode, eligiblePincodes = []) {
  const total = Number(grandTotal || 0);
  if (total >= COD_MAX_AMOUNT) return false;
  const pin = String(pincode || '').replace(/\D/g, '').slice(0, 6);
  if (!pin || pin.length !== 6) return false;
  return eligiblePincodes.includes(pin);
}

export function saveItemForLater(item) {
  try {
    const raw = localStorage.getItem('wishlistItems');
    const list = raw ? JSON.parse(raw) : [];
    const id = item.productId || item.id;
    if (!list.some((w) => String(w.productId || w.id) === String(id))) {
      list.push({
        productId: id,
        name: item.name,
        brand: item.brand,
        imageUrl: item.imageUrl,
        price: item.currentUnitPrice ?? item.discountPrice ?? item.price,
        partNumber: item.partNumber,
        savedAt: new Date().toISOString(),
      });
      localStorage.setItem('wishlistItems', JSON.stringify(list));
    }
    return true;
  } catch {
    return false;
  }
}
